var map = {
	"./image-carousel.de-CH.json": 1491,
	"./image-carousel.de-DE.json": 1492,
	"./image-carousel.en-CA.json": 1493,
	"./image-carousel.en-GB.json": 1494,
	"./image-carousel.en-IN.json": 1495,
	"./image-carousel.en-ME.json": 1496,
	"./image-carousel.en-US.json": 1497,
	"./image-carousel.es-EM.json": 1498,
	"./image-carousel.es-ES.json": 1499,
	"./image-carousel.fr-BE.json": 1500,
	"./image-carousel.fr-CA.json": 1501,
	"./image-carousel.fr-CH.json": 1502,
	"./image-carousel.nl-BE.json": 1503,
	"./image-carousel.nl-NL.json": 1504,
	"./image-carousel.pl-PL.json": 1505,
	"./image-carousel.pt-BR.json": 1506
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1490;